"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CommonStorage {
    constructor() {
        this.departments = [];
    }
    setDepartments(departments) {
        this.departments = departments;
    }
    getDepartments() {
        return this.departments;
    }
    reset() {
        this.departments = [];
    }
}
exports.default = CommonStorage;
